
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { formatDate, formatDateTime, formatDuration, WindowType } from '../../../../util';
import { Board, Card, Ticket } from '../../../backend/backendapi';
import { KanbanState } from '../../kanban.model';
import CardReadConfirmationsModal from '../CardReadConfirmationsModal';
import DurationInfoModal from '../duration/DurationInfoModal';
import VueFormIfSingularAttribute from '../VueFormIfSingularAttribute';
import AttributeDisplay from '../attributes/display/AttributeDisplay';

declare var window: WindowType;

@Component({
  components: {
    AttributeDisplay,
    CardReadConfirmationsModal,
    Comment: require('../comment/comment.vue.html').default,
    DurationInfoModal,
    VueFormIfSingularAttribute,
  },
})
export default class CardInfo extends Vue {
  @Prop({ required: true })
  state!: KanbanState;
  @Prop({ required: true })
  board!: Board;
  @Prop({ required: true })
  flow!: Ticket;
  @Prop({ required: true })
  card!: Card;

  get archivedBy(): string {
    if (!this.card.archivedBy) {
      return this.$t('kanbanUnknown').toString();
    }
    let user = this.state.users.find(e => e.id === this.card.archivedBy);
    if (!user) {
      return this.$t('kanbanUnknown').toString();
    }
    return user.email!;
  }

  get canShowDurationInfo(): boolean {
    return window.application.permissions.kanban.allowTimeRecording;
  }

  get createdBy(): string {
    if (!this.card.createdBy) {
      return this.$t('kanbanUnknown').toString();
    }
    let user = this.state.users.find(e => e.id === this.card.createdBy);
    if (!user) {
      return this.$t('kanbanUnknown').toString();
    }
    return user.email!;
  }

  get formattedDuration(): string {
    return formatDuration(this.card.durations?.map(e => e.seconds!).reduce((l, r) => l + r, 0) ?? 0);
  }

  get responsible(): string {
    if (!this.card.responsibles?.length)
      return '';
    return this.card.responsibles
        .sort((l, r) => (l.user?.lastName + ' ' + l.user?.firstName).toLocaleLowerCase().localeCompare((r.user?.lastName + ' ' + r.user?.firstName).toLocaleLowerCase()))
        .map(e => e.user?.firstName + ' ' + e.user?.lastName)
        .reduce((l, r) => l + ', ' + r);
  }

  formatDateTime(d: Date | undefined): string {
    if (!d)
      return '';
    if (window.application.kanban.kanbanshowtime) {
      return formatDateTime(d);
    } else {
      return formatDate(d);
    }
  }
}

